import { CardMedia as Mui4CardMedia, CardMediaProps as Mui4CardMediaProps } from '@material-ui/core'
import { default as Mui5CardMedia } from '@mui/material/CardMedia'
import { forwardRef } from 'react'
import { useComponentVersion } from '../hooks'
import { OsCardVersion } from './Card'

export type CardMediaProps = Mui4CardMediaProps
/** @deprecated Use CardMediaProps */
export type OsCardMediaProps = CardMediaProps

export const CardMedia = forwardRef<HTMLDivElement, CardMediaProps>((props, ref) => {
  const version = useComponentVersion('card')
  switch (version) {
    case OsCardVersion.V2:
      //@ts-ignore
      return <Mui5CardMedia ref={ref} {...props} />

    default:
      return <Mui4CardMedia ref={ref} {...props} />
  }
})
